import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/food-app/tasters")({
  component: () => <Outlet />,
});
